import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Row, Col, Form, Button } from "react-bootstrap";

import {
    fetchCompanyInfo,
    updateCompanyInfoById
} from "api/menu/master-files/company-info/actions";
import Spinner from "components/common/Spinner";

class CompanyInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            companyInfo: {},
            companyName: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.props.fetchCompanyInfo();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.companyInfo, this.props.companyInfo)) {
            this.setState({
                companyInfo: nextProps.companyInfo
            });
        }
    }

    componentWillUnmount() {
        this.props.fetchCompanyInfo(true);
    }

    handleChange = (e) => {
        const {
            name,
            value
        } = e.target;

        this.setState(prevState => ({
            companyInfo: {
                ...prevState.companyInfo,
                [name]: value
            }
        }));
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { companyInfo } = this.state;
        this.props.updateCompanyInfoById(companyInfo.companyId, companyInfo);
    };

    render() {
        const {
            loading
        } = this.props;
        const {
            companyInfo
        } = this.state;

        return (
            <div className="position-relative container dashboard">
                {!loading || <Spinner/>}
                <h3 className="mb-4">Company Info</h3>
                <form autoComplete="off" onSubmit={this.handleSubmit}
                      className="position-relative mb-5">
                    <Form.Group as={Row}>
                        <Form.Label column sm="2">Company Name</Form.Label>
                        <Col sm="5">
                            <Form.Control
                                type="text"
                                placeholder="Company Name"
                                name="companyName"
                                value={companyInfo.companyName || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input company name.
                            </Form.Control.Feedback>
                        </Col>

                        <Form.Label column sm="2">SMTP Server</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                type="text"
                                placeholder="SMTP Server"
                                name="smtpServer"
                                value={companyInfo.smtpServer || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input SMTP server.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>


                    <Form.Label className="font-weight-bold">Address</Form.Label>

                    <Form.Group as={Row}>
                        <Form.Label column sm="2">Line 1</Form.Label>
                        <Col sm="5">
                            <Form.Control
                                type="text"
                                placeholder="Line 1"
                                name="address1"
                                value={companyInfo.address1 || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input line 1.
                            </Form.Control.Feedback>
                        </Col>
                        <Form.Label column sm="2">Line 2</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                type="text"
                                placeholder="Line 2"
                                name="address2"
                                value={companyInfo.address2 || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input line 2.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>


                    <Form.Group as={Row}>
                        <Form.Label column sm="2">City</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                type="text"
                                placeholder="City"
                                name="city"
                                value={companyInfo.city || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input city.
                            </Form.Control.Feedback>
                        </Col>
                        <Form.Label column sm="1">Province</Form.Label>
                        <Col sm="1">
                            <Form.Control
                                type="text"
                                placeholder="Province"
                                name="province"
                                value={companyInfo.province || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input province.
                            </Form.Control.Feedback>
                        </Col>
                        <Form.Label column sm="2">Postal Code</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                type="text"
                                placeholder="Postal Code"
                                name="postalCode"
                                value={companyInfo.postalCode || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input postal code.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                        <Form.Label column sm="2">Phone</Form.Label>
                        <Col sm="4">
                            <Form.Control
                                type="text"
                                placeholder="Phone"
                                name="phone"
                                value={companyInfo.phone || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input phone.
                            </Form.Control.Feedback>
                        </Col>
                        <Col sm="1"></Col>
                        <Form.Label column sm="2">Fax</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                type="text"
                                placeholder="Fax"
                                name="fax"
                                value={companyInfo.fax || ""}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input fax.
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Row>
                        <Col sm="8">
                            <Form.Label className="font-weight-bold">Billing</Form.Label>
                            <Row>
                                <Col sm="6">
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="6">Next Invoice Number</Form.Label>
                                        <Col sm="4">
                                            <Form.Control
                                                type="text"
                                                placeholder="Next Invoice Number"
                                                name="nextInvoiceNumber"
                                                value={companyInfo.nextInvoiceNumber || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input next invoice number.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row}>
                                        <Form.Label column sm="6">GST Number</Form.Label>
                                        <Col sm="4">
                                            <Form.Control
                                                type="text"
                                                placeholder="GST Number"
                                                name="gstNumber"
                                                value={companyInfo.gstNumber || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input GST number.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="6">CAD to USD Rate</Form.Label>
                                        <Col sm="4">
                                            <Form.Control
                                                type="text"
                                                placeholder="CAD to USD Rate"
                                                name="currentRate"
                                                value={companyInfo.currentRate || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input CAD to USD Rate.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col sm="6">
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="4">PST %</Form.Label>
                                        <Col sm="5">
                                            <Form.Control
                                                type="text"
                                                placeholder="PST %"
                                                name="taxPST"
                                                value={companyInfo.taxPST || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input tax PST.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row}>
                                        <Form.Label column sm="4">US GST %</Form.Label>
                                        <Col sm="5">
                                            <Form.Control
                                                type="text"
                                                placeholder="US GST %"
                                                name="taxGST"
                                                value={companyInfo.taxGST || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input US GST %.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row}>
                                        <Form.Label column sm="4">USD GST Code</Form.Label>
                                        <Col sm="5">
                                            <Form.Control
                                                type="text"
                                                placeholder="USD GST Code"
                                                name="taxGSTCode"
                                                value={companyInfo.taxGSTCode || ""}
                                                onChange={this.handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please input USD GST Code.
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Label className="font-weight-bold">MYOB Export</Form.Label>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Next Batch Number</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Next Batch Number"
                                        name="nextBatchNumber"
                                        value={companyInfo.nextBatchNumber || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input next batch number.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Export Folder</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Export Folder"
                                        name="exportFolder"
                                        value={companyInfo.exportFolder || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please select export folder.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Label className="font-weight-bold">
                                Merchandiser Invoicing
                            </Form.Label>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Filename</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Filename"
                                        name="serviceInvoiceExportFilename"
                                        value={companyInfo.serviceInvoiceExportFilename || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input filename.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Service Account</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Filename"
                                        name="serviceInvoiceAccount"
                                        value={companyInfo.serviceInvoiceAccount || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input service account.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Misc Charges Account</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Misc Charges Account"
                                        name="miscChargesAccount"
                                        value={companyInfo.miscChargesAccount || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input misc charges account.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">GST Account</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="GST Account"
                                        name="gstAccount"
                                        value={companyInfo.gstAccount || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input GST account.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Label className="font-weight-bold">Client Invoicing</Form.Label>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Filename</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Filename"
                                        name="clientInvoiceExportFilename"
                                        value={companyInfo.clientInvoiceExportFilename || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input filename.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="3">Account</Form.Label>
                                <Col sm="9">
                                    <Form.Control
                                        type="text"
                                        placeholder="Account"
                                        name="clientInvoiceAccount"
                                        value={companyInfo.clientInvoiceAccount || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please input account.
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                        </Col>

                        <Col sm="4">
                            <Form.Label className="font-weight-bold">CDN Tax Rates &
                                Codes</Form.Label>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">AB</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTAB"
                                        value={companyInfo.taxHSTAB || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTABCode"
                                        value={companyInfo.taxHSTABCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">BC</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTBC"
                                        value={companyInfo.taxHSTBC || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTBCCode"
                                        value={companyInfo.taxHSTBCCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">MB</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTMB"
                                        value={companyInfo.taxHSTMB || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTMBCode"
                                        value={companyInfo.taxHSTMBCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">NB</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNB"
                                        value={companyInfo.taxHSTNB || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNBCode"
                                        value={companyInfo.taxHSTNBCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">NF</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNF"
                                        value={companyInfo.taxHSTNF || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNFCode"
                                        value={companyInfo.taxHSTNFCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">NS</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNS"
                                        value={companyInfo.taxHSTNS || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNSCode"
                                        value={companyInfo.taxHSTNSCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">NT</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNT"
                                        value={companyInfo.taxHSTNT || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNTCode"
                                        value={companyInfo.taxHSTNTCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">NU</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNU"
                                        value={companyInfo.taxHSTNU || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTNUCode"
                                        value={companyInfo.taxHSTNUCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">ON</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTON"
                                        value={companyInfo.taxHSTON || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTONCode"
                                        value={companyInfo.taxHSTONCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">PE</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTPE"
                                        value={companyInfo.taxHSTPE || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTPECode"
                                        value={companyInfo.taxHSTPECode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">QC</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTQC"
                                        value={companyInfo.taxHSTQC || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTQCCode"
                                        value={companyInfo.taxHSTQCCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">SK</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTSK"
                                        value={companyInfo.taxHSTSK || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTSKCode"
                                        value={companyInfo.taxHSTSKCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Form.Label column sm="2">YT</Form.Label>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTYT"
                                        value={companyInfo.taxHSTYT || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm="5">
                                    <Form.Control
                                        type="text"
                                        name="taxHSTYTCode"
                                        value={companyInfo.taxHSTYTCode || ""}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="text-right">
                        <Button type="submit">Update</Button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    companyInfo: state.companyInfo.companyInfo,
    loading: state.companyInfo.loading
});

const mapStateToDispatch = dispatch => ({
    fetchCompanyInfo: bindActionCreators(fetchCompanyInfo, dispatch),
    updateCompanyInfoById: bindActionCreators(updateCompanyInfoById, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(CompanyInfo);
